import { render, staticRenderFns } from "./BoletoView.vue?vue&type=template&id=99dede22&"
import script from "./BoletoView.vue?vue&type=script&lang=js&"
export * from "./BoletoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports